import { render, staticRenderFns } from "./LDrawerSummary.vue?vue&type=template&id=1d0a8487&scoped=true"
import script from "./LDrawerSummary.vue?vue&type=script&lang=js"
export * from "./LDrawerSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0a8487",
  null
  
)

export default component.exports